import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export interface IUpdateDelegatedAccessVariables {
	delegatedAccess: Api.IDelegatedAccess;
	user: Api.IUser;
}

export function useUpdateDelegatedAccessMutation({
	impersonationContext,
	onError,
	onSuccess,
}: {
	impersonationContext?: Api.IImpersonationContext;
	onError?: (error: Api.IOperationResultNoValue, variables: IUpdateDelegatedAccessVariables) => void;
	onSuccess?: (data: void, variables: IUpdateDelegatedAccessVariables) => void;
} = {}) {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({ delegatedAccess, user }: IUpdateDelegatedAccessVariables) => {
			return userSession.webServiceHelper.callAsync<void>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `user/${encodeURIComponent(user.id)}/delegatedAccess`,
				}),
				'PUT',
				delegatedAccess
			);
		},
		onError,
		onSuccess,
	});
}
